// extracted by mini-css-extract-plugin
export default {"container":"FetchComponent_container__3z3Bj","one":"FetchComponent_one__6VB6X"};